import React from 'react';
import { Outlet } from 'react-router-dom';
import cn from 'bem-cn';

import radialBackground from '../../images/radial.svg';
import { RoutePaths } from '../../constants';

import { useLocalStorageForm } from '../NewPromptPage/NewPromptPage.hooks';
// import { copyToClipboard } from '../../utils/clipboard/clipboard';

import { WebAppLayout } from '../../layouts/WebAppLayout';
import { useNavigateBack } from '../../hooks';
import { HeaderElements } from '../../components/Header';
import { NavigationElements } from '../../components/Navigation';
import { Stack, Tabs, InfoBlock, Link, ImageWithFadeIn, Banner, Slider } from '../../components/UI';
import { TabItem } from '../../components/UI/Tabs/Tabs.types';
import { Profile } from '../../components/Profile/Profile';
import { useUserContext, useModal } from '../../contexts';

import trophy from '../../images/trophy.png';

import './MyProfilePage.scss';

const b = cn('my-profile-page');

export const MyProfilePage: React.FC = () => {
    const { user } = useUserContext();

    const { howToEarnPoints } = useModal();
    const handleBackButtonClick = useNavigateBack();

    const { formData } = useLocalStorageForm();
    const isDraftExists = formData.promptText || formData.step > 1;

    const tabItems: TabItem[] = [
        {
            text: 'Промпты',
            icon: 'prompt',
            to: RoutePaths.ProfilePrompts,
        },
        // {
        //     text: 'Избранное',
        //     icon: 'heart',
        //     to: RoutePaths.ProfileFavorites,
        // },
        {
            text: 'Рейтинг',
            icon: 'rating',
            to: RoutePaths.ProfileRating,
            disabled: true,
            popoverText: 'Вот-вот появится',
        },
    ];

    // const handleShareClick = async () => {
    //     const link = `${window.location.hostname}/prompthub/users/${user.uid}`;

    //     if (navigator.share) {
    //         try {
    //             await navigator.share({
    //                 title: 'Промптхаб — платформа обмена идеями, как использовать Алису AI и другие нейросети',
    //                 text: 'Мой профиль в Промптхабе',
    //                 url: link,
    //             });
    //         } catch {}
    //     } else {
    //         copyToClipboard(link);
    //     }
    // };

    const headerElements: HeaderElements = {
        desktop: {
            left: {
                type: 'logo',
            },
            right: {
                type: 'profile',
            },
        },
        mobile: {
            left: {
                type: 'backButton',
                onClick: handleBackButtonClick,
            },
            center: {
                type: 'custom',
                render: () => {
                    return <span className={b('header-text')}>ИИ профиль</span>;
                },
            },
            // right: {
            //     type: 'custom',
            //     render: () => {
            //         return <Icon name="share" size={24} fillColor="rgba(0, 0, 0, 0.9)" onClick={handleShareClick} />;
            //     },
            // },
        },
    };

    const emptyNavigationElements: NavigationElements = {
        desktop: [],
        mobile: [],
    };

    return (
        <WebAppLayout headerElements={headerElements} navigationElements={emptyNavigationElements}>
            <div className={b('background')}>
                <ImageWithFadeIn src={radialBackground} alt="" />
            </div>
            <Stack spacing={24}>
                <Profile avatarSrc={user.avatarSrc} firstName={user.firstName} lastName={user.lastName} />
                <Slider className={b('slider')}>
                    {isDraftExists && (
                        <Link to={RoutePaths.NewPrompt} className={b('draft-info-block')}>
                            <InfoBlock text="Продолжить заполнение промпта" />
                        </Link>
                    )}
                    <Banner
                        text="Узнайте, как получить баллы и подняться в рейтинге"
                        image={trophy}
                        onClick={howToEarnPoints.open}
                    />
                </Slider>
                <div className={b('tabs')}>
                    <Tabs items={tabItems} />
                </div>
                <div className={b('content')}>
                    <Outlet />
                </div>
            </Stack>
        </WebAppLayout>
    );
};
